<template>
  <BasePageContent>
    <VendorUpdate
      v-if="true"
      :uuid="uuid"
      @onsave="OnSave"
      @oncancel="OnCancel"
      cancel-text="Cancel"
    />
  </BasePageContent>
</template>

<script>
import VendorUpdate from "@/components/ui/vendor/VendorUpdate.vue";
// import { useRouter } from "vue-router";
export default {
  components: { VendorUpdate },
  props: {
    uuid: {
      type: String,
    },
  },
  setup() {
    const OnSave = () => {
      // router.replace({ name: "vendor-detail", params: { uuid: props.uuid } });
    };
    // const router = useRouter();
    const OnCancel = () => {
      // router.replace({ name: "vendor-detail", params: { uuid: props.uuid } });
    };
    return {
      OnSave,
      OnCancel,
    };
  },
};
</script>